export const educationData = [
  {
    id: 1,
    institution:
      "ESPRIT (Private Higher School of Engineering and Technology) ",
    course: "Computer science engineering",
    startYear: "2019",
    endYear: "2022",
  },
  {
    id: 2,
    institution: "Higher institute of technological studies ISET Rades",
    course: "Electrical engineering bachelor",
    startYear: "2015",
    endYear: "2019",
  },
];
